import { render, staticRenderFns } from "./AddImageButton.vue?vue&type=template&id=54d37a1a"
import script from "./AddImageButton.vue?vue&type=script&lang=js"
export * from "./AddImageButton.vue?vue&type=script&lang=js"
import style0 from "./AddImageButton.vue?vue&type=style&index=0&id=54d37a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports